<template>
  <div>
    <Detail class="mb-5" />
    <RegistryList />
  </div>
</template>

<script>
export default {
  name: 'RegistryDetail',
  data() {
    return {
      loading: true,
    }
  },
  created() {
    setTimeout(() => {
      this.loading = false
    }, 1000)
  },
  components: {
    Detail: () => import('@/components/registry/Detail'),
    RegistryList: () => import('@/components/registry/RegistryList'),
  },
}
</script>
